var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1457_8039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45004 7.95039H7.67504C7.15004 7.95039 6.72504 7.55039 6.72504 7.05039C6.72504 6.55039 7.15004 6.15039 7.67504 6.15039H10.25C10.55 6.15039 10.8 5.90039 10.8 5.60039C10.8 5.30039 10.55 5.05039 10.25 5.05039H9.05004V4.45039C9.05004 4.15039 8.80004 3.90039 8.50004 3.90039C8.20004 3.90039 7.95004 4.15039 7.95004 4.45039V5.05039H7.67504C6.52504 5.05039 5.60004 5.95039 5.60004 7.07539C5.60004 8.20039 6.52504 9.10039 7.67504 9.10039H9.45004C9.97504 9.10039 10.4 9.50039 10.4 10.0004C10.4 10.5004 9.97504 10.9004 9.45004 10.9004H6.75004C6.45004 10.9004 6.20004 11.1504 6.20004 11.4504C6.20004 11.7504 6.45004 12.0004 6.75004 12.0004H7.95004V12.6004C7.95004 12.9004 8.20004 13.1504 8.50004 13.1504C8.80004 13.1504 9.05004 12.9004 9.05004 12.6004V12.0004H9.45004C10.6 12.0004 11.525 11.1004 11.525 9.97539C11.55 8.85039 10.6 7.95039 9.45004 7.95039Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50001 0.950195C4.32501 0.950195 0.950012 4.3252 0.950012 8.5002C0.950012 12.6752 4.32501 16.0502 8.50001 16.0502C12.675 16.0502 16.05 12.6752 16.05 8.5002C16.05 4.3252 12.675 0.950195 8.50001 0.950195ZM8.50001 14.9502C4.95001 14.9502 2.05001 12.0502 2.05001 8.5002C2.05001 4.9502 4.95001 2.0502 8.50001 2.0502C12.05 2.0502 14.95 4.9502 14.95 8.5002C14.95 12.0502 12.05 14.9502 8.50001 14.9502Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1457_8039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/coin.00139e7ecbb18e9d8d785a309d75ffae.svg";